import DraftEditorEditHandler from 'draft-js/lib/DraftEditorEditHandler';
import DraftModifier from 'draft-js/lib/DraftModifier';
import EditorState from 'draft-js/lib/EditorState';

const { onCompositionStart } = DraftEditorEditHandler;

// draft-js 0.11.7 resolves an IME composition by re-reading only the leaf that
// received the composed text, so a non-collapsed selection spanning several
// blocks or leaves is deleted from the DOM by the browser but survives in the
// ContentState and is rendered back. Removing the range before the browser
// composes keeps the two in step. The Editor copies this handler object when it
// is constructed, so this module has to run before the first Editor mounts.
DraftEditorEditHandler.onCompositionStart = (editor, e) => {
  // eslint-disable-next-line no-underscore-dangle -- draft-js keeps the live state here
  const editorState = editor._latestEditorState;
  const selection = editorState.getSelection();
  if (!selection.isCollapsed()) {
    const contentState = DraftModifier.removeRange(
      editorState.getCurrentContent(),
      selection,
      'backward',
    );
    editor.update(
      EditorState.forceSelection(
        EditorState.push(editorState, contentState, 'remove-range'),
        contentState.getSelectionAfter(),
      ),
    );
  }
  onCompositionStart(editor, e);
};
